var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchitectureBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 21.978,
    viewBox: "0 0 22 21.978",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Archi",
    d: "M123.606,50.706a3.138,3.138,0,0,0-3.03,2.356h-9.535a3.141,3.141,0,0,1,0-6.282h1.682a3.126,3.126,0,0,0,6.06,0h1.682a4.712,4.712,0,1,0,0-9.424H110.93a3.141,3.141,0,1,0,0,1.571h9.535a3.141,3.141,0,0,1,0,6.282h-1.682a3.126,3.126,0,0,0-6.06,0h-1.682a4.712,4.712,0,1,0,0,9.424h9.535a3.136,3.136,0,1,0,3.03-3.927ZM107.9,39.712a1.572,1.572,0,1,1,1.11-.461A1.571,1.571,0,0,1,107.9,39.712Zm7.853,4.712a1.572,1.572,0,1,1-1.11.461A1.571,1.571,0,0,1,115.753,44.424Zm7.853,10.994a1.572,1.572,0,1,1,1.11-.461A1.571,1.571,0,0,1,123.606,55.418Z",
    transform: "translate(-104.747 -35)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchitectureBlack);
export default __webpack_public_path__ + "static/media/Architecture_black.18fc97f9c466460f48f6f190fe271aef.svg";
export { ForwardRef as ReactComponent };